 
export class MultipleChoiceAfslut {
        public konkurrenceId: string;
        public delopgaveId: string;
        public holdId: string;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/MultipleChoiceAfslut.ts